export default "__VITE_ASSET__CiHF7z3F__"